import { useContext } from 'react'
import { useSelector } from '@xstate/react'
import { RefRegisterStateMachine } from '@/pages/refregisters/[entityId]'
import { refRegisterStateMachine } from '@isdd/metais-common/components/state-machine/refRegistersStatusStateMachine'

export const useRefRegisterStateMachine = () => {
    const actorRef = useContext(RefRegisterStateMachine)
    if (!actorRef) throw new Error('Missing provider')

    const snapshot = useSelector(actorRef, (s) => s)

    const currentState = snapshot.value

    const allPossibleTransitions = refRegisterStateMachine.states[currentState as string]?.on
        ? Object.keys(refRegisterStateMachine.states[currentState as string].on)
        : []

    return {
        send: actorRef.send,
        currentState,
        isInitialState: (state: string) => currentState === state,
        allPossibleTransitions,
    }
}
